const styles = theme => ({
    search: {
        marginBottom: 30
    }
});

export default styles;